import React, { useEffect } from 'react';
import { X, ExternalLink, Download } from 'lucide-react';

/**
 * Certificate modal viewer.
 * Shows the PDF in an iframe with options to open in new tab or download.
 * Closes on backdrop click, close button, or Escape key.
 */
export const CertificateModal = ({ cert, onClose }) => {
  useEffect(() => {
    if (!cert) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [cert, onClose]);

  if (!cert) return null;

  return (
    <div className="cert-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-label={cert.title}>
      <div className="cert-modal" onClick={(e) => e.stopPropagation()}>
        <header className="cert-modal-header">
          <div>
            <span className="cert-modal-eyebrow">Certificate</span>
            <h3 className="cert-modal-title">{cert.title}</h3>
            <p className="cert-modal-issuer">{cert.issuer}</p>
          </div>
          <button onClick={onClose} className="cert-modal-close" aria-label="Close">
            <X className="w-5 h-5" />
          </button>
        </header>
        <div className="cert-modal-body">
          {/\.(png|jpe?g|webp|gif)$/i.test(cert.link) ? (
            <img
              src={cert.link}
              alt={cert.title}
              className="cert-modal-image"
            />
          ) : (
            <iframe
              src={cert.link}
              title={cert.title}
              className="cert-modal-iframe"
            />
          )}
        </div>
        <footer className="cert-modal-footer">
          <a href={cert.link} target="_blank" rel="noopener noreferrer" className="cert-modal-action">
            <ExternalLink className="w-4 h-4" />
            <span>Open in new tab</span>
          </a>
          <a href={cert.link} download className="cert-modal-action cert-modal-action-primary">
            <Download className="w-4 h-4" />
            <span>Download</span>
          </a>
        </footer>
      </div>
    </div>
  );
};
